import { createContext } from 'react'

export function getHeaderLabel(th: HTMLElement) {
  // Esclude le icone (es. SortControl) dal testo dell'intestazione
  const clone = th.cloneNode(true) as HTMLElement
  clone
    .querySelectorAll('.material-icons, .material-icons-outlined')
    .forEach((icon) => icon.remove())
  return clone.textContent?.trim() ?? ''
}

// Elemento sopra la tabella in cui Sorter mostra il menu "Ordina per" su mobile
export const SortSlotContext = createContext<HTMLElement | null>(null)
